import {getDionysus} from 'services/dionysus'
import useSWR from 'swr'
import type {SupportedCountryResponse} from 'types/countries'

export const useSupportedCountries = () =>
    useSWR<SupportedCountryResponse[], Error>('rest/v1/supported-countries', getDionysus)
